import Exit from "@assets/images/icons/exit_to_app.svg";
import { profileType } from "../../../utils/enum";

export const addToZoho = {
  icon: <Exit />,
  name: "Export to Zoho",
};

export const addToHubspot = {
  icon: <Exit />,
  name: "Export to Hubspot",
};

export const tabDataHandler = [
  {
    name: "Importers-Exporters",
    value: profileType.company,
  },
  {
    name: "Logistics Companies",
    value: profileType.logistics,
  },
];

export const logisticsFilters = {
  tagList: [],
  type: [],
  contacts: [],
};

export const companyFilters = {
  tagList: [],
  contacts: [],
};

export let companyPayload = {
  type: profileType.company,
  filters: { ...companyFilters },
  company_name: "",
  from: 0,
};

export let logisticsPayload = {
  type: profileType.logistics,
  filters: { ...logisticsFilters },
  company_name: "",
  from: 0,
};

export const companyType = {
  import: "I",
  export: "E",
};

export const pendoEventType = {
  logistics: "_companies_logistics_companies_",
  company: "_companies_importers_exporters_",
};

export const mainContactTabs = {
  company: "company",
  ai: "ai",
};
